import React, { useState, useReducer, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Link, Navigate, useParams } from "react-router-dom";
import {
  Paper,
  Chip,
  Button,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Dialog,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Typography,
  Stack,
  IconButton,
} from '@mui/material';
import {
  VirtualTableState,
  SortingState,
  DataTypeProvider,
  FilteringState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableColumnResizing,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';
import DateRange from '@mui/icons-material/DateRange';
import TimeAgo from 'react-timeago'

import utils from '../utils'
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import EcuHistoryTable from './EcuHistoryTable';

// ************************************************************
// ************************************************************
// ************************************************************

export const EcuDetailsComponentWrapper = (props) => {
  const { ecu_id } = useParams()
  const navigate = useNavigate()
  return <EcuDetails
    ecu_id={ecu_id}
    navigate={navigate}
    {...props}
  />
}

class EcuDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      first: true,
      ecu_history: undefined,
      current_ecu_id: this.props.ecu_id,
      current_ecu_uid: "",
      prod_date: "",
    }
  }
  async componentDidMount() {
    this.loadEcuDetails(this.props.ecu_id)    
  } 
  async componentDidUpdate() {
    if (this.state.current_ecu_id !== this.props.ecu_id) {
      this.loadEcuDetails(this.props.ecu_id)    
    }
  } 
  async loadEcuDetails(ecu_id) { 
    await this.setState({
      loaded: false,
      ecu_history: undefined,
      current_ecu_id: ecu_id,
      current_ecu_uid: "",
    })

    var data = await AuthService.getEcuHistory(ecu_id)
    var temp = utils.ecuHistoryFixer(data.rows)
    //console.log(data.uid_value)
    await this.setState({
      loaded: true,
      ecu_history: temp,
      current_ecu_uid: data.uid_value,
    })
    data = await AuthService.getEcuProdDate(ecu_id)
    console.log(data)
    await this.setState({
      prod_date: data.value,
    })
  }
  render() {
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />
    //if (!utils.userHasRoleAdmin(this.props.authStatus.user)) return <UserAuthRequired notallowed />
    
    return (
      <EcuHistoryTable 
        prod_date={this.state.prod_date} 
        ecu_id={this.state.current_ecu_id} 
        ecu_uid={this.state.current_ecu_uid} 
        ecu_history={this.state.ecu_history} 
        />
    )
  }
}
